/* eslint-disable no-underscore-dangle */
import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(advancedFormat);

const BlogItem = ({ post, preview = false }) => {
  const strippedString = post.extract?.replace(/(<([^>]+)>)/gi, '');
  const coverImage = post.coverImageInput ?? post.coverImage;
  return (
    <article className="mx-auto my-0" style={{ maxWidth: 800 }}>
      <Link
        href="/blog/[slug]"
        as={`/blog/${post.slug}`}
        className="block mb-10 overflow-hidden transition-shadow duration-300 ease-in-out bg-white rounded-lg shadow-md md:mb-22 hover:shadow-xl"
      >
        {coverImage && (
          <figure className="relative p-0 m-0 overflow-hidden rounded-t-lg border-neutral-200 border-lg">
            <Image
              layout="responsive"
              width={800}
              height={400}
              quality={100}
              loading="lazy"
              src={coverImage}
              alt={`${post.title} cover`}
              sizes="(max-width: 767px) 500px, (max-width: 991px) 800px, 800px"
            />
          </figure>
        )}
        {preview ? (
          <div className="p-2 text-sm font-medium text-center text-white uppercase bg-gradient-x">
            {post._status}
          </div>
        ) : null}
        <div className="p-8 md:px-30">
          {post.category && (
            <h6 className="pt-1 mb-1 text-base font-medium text-pink tracking-1">
              {post.category.value?.data.name}
            </h6>
          )}
          <h4 className="pt-1 mb-4 text-2xl font-normal text-black md:text-3xl">{post.title}</h4>
          <p className="pt-2 mb-10 text-base font-normal text-black text-opacity-80">
            {strippedString}
          </p>
          <p className="text-base font-normal text-black text-opacity-50">
            {dayjs(post.date).format('MMM Do, YYYY')}
          </p>
        </div>
      </Link>
    </article>
  );
};

export default BlogItem;
